import DefaultPalette from './theme';

const colors = {
  blue: ['#E6F4FF', '#BAE0FF', '#91CAFF', '#69B1FF', '#4096FF', '#1677FF', '#0958D9', '#003EB3', '#002C8C', '#001D66'],
  red: ['#FFF1F0', '#FFCCC7', '#FFA39E', '#FF7875', '#FF4D4F', '#F5222D', '#CF1322', '#A8071A', '#820014', '#5C0011'],
  gold: ['#FFFBE6', '#FFF1B8', '#FFE58F', '#FFD666', '#FFC53D', '#FAAD14', '#D48806', '#AD6800', '#874D00', '#613400'],
  cyan: ['#E6FFFB', '#B5F5EC', '#87E8DE', '#5CDBD3', '#36CFC9', '#13C2C2', '#08979C', '#006D75', '#00474F', '#002329'],
  green: ['#F6FFED', '#D9F7BE', '#B7EB8F', '#95DE64', '#73D13D', '#52C41A', '#389E0D', '#237804', '#135200', '#092B00'],
  grey: [
    '#FFFFFF',
    '#FAFAFA',
    '#F5F5F5',
    '#F0F0F0',
    '#D9D9D9',
    '#BFBFBF',
    '#8C8C8C',
    '#595959',
    '#434343',
    '#262626',
    '#141414',
    '#000000',
    '#111111',
    '#1F1F1F',
    '#2D2D2D',
    '#FCFCFC',
    '#171717'
  ]
};

export function buildPalette() {
  const base = DefaultPalette(colors);
  const white = '#ffffff';
  const black = '#141414';

  return {
    light: {
      ...base,
      common: { black, white },
      divider: '#F0F0F0',
      background: {
        paper: white,
        default: '#F8FAFC'
      },
      text: {
        primary: '#1F2937',
        secondary: '#6B7280',
        disabled: '#9CA3AF'
      },
      action: {
        active: '#6B7280',
        hover: 'rgba(17, 24, 39, 0.04)',
        selected: 'rgba(17, 24, 39, 0.08)',
        disabled: 'rgba(17, 24, 39, 0.26)',
        disabledBackground: 'rgba(17, 24, 39, 0.12)',
        focus: 'rgba(17, 24, 39, 0.12)',
        hoverOpacity: 0.04,
        disabledOpacity: 0.38
      }
    }
  };
}

